export default "__VITE_ASSET__BqrO8GU7__"